import type { Video } from '@/types';

export const videos: Video[] = [
  {
    id: 'chang-ye-jiang-ming',
    title: '长夜将明',
    type: 'movie',
    genres: ['悬疑', '剧情', '犯罪'],
    year: 2025,
    region: '中国大陆',
    rating: 8.9,
    director: '陈砚舟',
    actors: ['张砚清', '林知远', '周晚晴'],
    synopsis:
      '一桩沉寂二十年的悬案因一卷旧磁带重新浮出水面。刑警队长沈默在追查真相的过程中，逐渐发现自己最信任的师父竟与案件有着千丝万缕的联系。当黎明来临之前，每个人都必须在良知与情义之间做出选择。',
    episodeCount: 1,
    status: '已上映',
    updatedAt: '2025-10-08 21:30',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20noir%20movie%20poster%20of%20a%20lone%20detective%20silhouette%20standing%20in%20rain%20soaked%20city%20street%20at%20night%2C%20deep%20navy%20and%20amber%20lighting%2C%20moody%20atmosphere%2C%20film%20grain%2C%20dramatic%20shadows&width=600&height=900&seq=hn-poster-changye&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20cityscape%20with%20neon%20amber%20reflections%20on%20wet%20asphalt%2C%20lone%20figure%20walking%20under%20streetlamps%2C%20deep%20navy%20tones%2C%20suspense%20film%20still%2C%20atmospheric%20fog&width=1600&height=900&seq=hn-back-changye&orientation=landscape',
    isHot: true,
  },
  {
    id: 'shan-hai-ji-gui-xu',
    title: '山海纪 · 归墟',
    type: 'movie',
    genres: ['奇幻', '冒险', '动作'],
    year: 2024,
    region: '中国大陆',
    rating: 8.2,
    director: '苏怀山',
    actors: ['陆离', '白露', '程野'],
    synopsis:
      '传说中沉入归墟的古老神鼎重现人间，少年陆离被迫卷入一场跨越山海两界的争夺。他带着失落的族徽踏上旅途，在神兽与迷阵之间寻找真相，也重新理解了力量与守护的意义。',
    episodeCount: 1,
    status: '已上映',
    updatedAt: '2025-09-28 20:10',
    poster:
      'https://readdy.ai/api/search-image?query=Epic%20fantasy%20film%20poster%20with%20a%20young%20hero%20holding%20a%20glowing%20ancient%20relic%2C%20misty%20mountains%20and%20floating%20islands%20behind%2C%20warm%20amber%20and%20teal%20gradient%20sky%2C%20cinematic%20dramatic%20lighting&width=600&height=900&seq=hn-poster-shanhai&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Fantasy%20landscape%20of%20floating%20mountain%20islands%20above%20a%20sea%20of%20clouds%2C%20golden%20sunrise%20light%2C%20ancient%20oriental%20architecture%2C%20mystical%20epic%20atmosphere%20with%20soft%20mist&width=1600&height=900&seq=hn-back-shanhai&orientation=landscape',
    isHot: true,
  },
  {
    id: 'wu-sheng-zhi-jing',
    title: '无声之境',
    type: 'movie',
    genres: ['剧情', '家庭'],
    year: 2025,
    region: '中国大陆',
    rating: 8.6,
    director: '何知微',
    actors: ['宋清扬', '许安'],
    synopsis:
      '一位失聪的调音师与不擅表达的父亲在南方小城度过一个漫长的夏天。他们靠着振动、光线和纸笔重新学会交谈，也在沉默中找回了被生活磨平的温柔。',
    episodeCount: 1,
    status: '已上映',
    updatedAt: '2025-10-01 19:40',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20minimal%20drama%20film%20poster%20of%20a%20young%20man%20tuning%20an%20old%20piano%20beside%20a%20window%2C%20soft%20afternoon%20sunlight%2C%20muted%20terracotta%20and%20cream%20tones%2C%20quiet%20tender%20mood&width=600&height=900&seq=hn-poster-wusheng&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sunlit%20southern%20chinese%20town%20alleyway%20in%20summer%20with%20old%20brick%20walls%20and%20hanging%20plants%2C%20warm%20amber%20light%20through%20leaves%2C%20gentle%20nostalgic%20film%20still&width=1600&height=900&seq=hn-back-wusheng&orientation=landscape',
    isHot: false,
  },
  {
    id: 'zhui-feng-zhe',
    title: '追风者',
    type: 'movie',
    genres: ['动作', '犯罪', '悬疑'],
    year: 2024,
    region: '中国香港',
    rating: 7.9,
    director: '冯启元',
    actors: ['高子墨', '黎晴'],
    synopsis:
      '一名退役赛车手被卷入跨城走私案，为了替哥哥洗清冤屈，他重新回到方向盘后。速度与真相在深夜的公路上同时加速，而终点线之外，是一场更危险的赌局。',
    episodeCount: 1,
    status: '已上映',
    updatedAt: '2025-09-20 22:05',
    poster:
      'https://readdy.ai/api/search-image?query=High%20octane%20action%20movie%20poster%20of%20a%20race%20car%20speeding%20through%20a%20night%20tunnel%20with%20orange%20light%20trails%2C%20dark%20blue%20shadow%2C%20dynamic%20motion%20blur%2C%20bold%20dramatic%20composition&width=600&height=900&seq=hn-poster-zhuifeng&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Rainy%20city%20highway%20at%20night%20with%20racing%20car%20headlights%20and%20orange%20neon%20reflections%2C%20cinematic%20action%20film%20still%2C%20dark%20navy%20palette%20with%20glowing%20streaks&width=1600&height=900&seq=hn-back-zhuifeng&orientation=landscape',
    isHot: true,
  },
  {
    id: 'guang-yin-de-gu-shi',
    title: '光阴的故事',
    type: 'movie',
    genres: ['剧情', '爱情'],
    year: 2023,
    region: '中国大陆',
    rating: 8.4,
    director: '沈亦白',
    actors: ['顾南', '叶知秋'],
    synopsis:
      '从老式照相馆到数码时代，一对青梅竹马用一卷卷胶片记录彼此的成长。多年后他们在一场旧照片展上重逢，才发现有些话早在快门按下时就已说出口。',
    episodeCount: 1,
    status: '已上映',
    updatedAt: '2025-08-15 18:20',
    poster:
      'https://readdy.ai/api/search-image?query=Nostalgic%20romance%20film%20poster%20with%20two%20silhouettes%20under%20film%20strips%20and%20warm%20projector%20light%2C%20sepia%20and%20amber%20tones%2C%20tender%20retro%20mood%2C%20soft%20grain&width=600&height=900&seq=hn-poster-guangyin&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Vintage%20photo%20studio%20in%20warm%20afternoon%20light%20with%20hanging%20film%20negatives%20and%20old%20cameras%2C%20amber%20and%20brown%20tones%2C%20nostalgic%20cinematic%20mood&width=1600&height=900&seq=hn-back-guangyin&orientation=landscape',
    isHot: false,
  },
  {
    id: 'xing-he-chang-ge',
    title: '星河长歌',
    type: 'tv',
    genres: ['古装', '爱情', '奇幻'],
    year: 2025,
    region: '中国大陆',
    rating: 8.7,
    director: '温惜言',
    actors: ['姜挽', '萧临', '柳青禾'],
    synopsis:
      '执掌星象的少女与背负诅咒的将军因一场星陨相遇。为了改写注定分离的命格，他们踏遍九州寻找散落的星辰碎片，在乱世中守护彼此与家国。',
    episodeCount: 40,
    status: '更新至 24 集',
    updatedAt: '2025-10-11 20:00',
    poster:
      'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20poster%20with%20a%20woman%20in%20flowing%20robes%20under%20a%20starry%20night%20sky%20and%20a%20general%20in%20armor%2C%20deep%20indigo%20with%20golden%20accents%2C%20ethereal%20elegant%20mood&width=600&height=900&seq=hn-poster-xinghe&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Majestic%20ancient%20chinese%20palace%20under%20a%20brilliant%20starry%20galaxy%2C%20golden%20lanterns%20and%20indigo%20night%20sky%2C%20epic%20historical%20fantasy%20cinematic%20scene&width=1600&height=900&seq=hn-back-xinghe&orientation=landscape',
    isHot: true,
  },
  {
    id: 'an-yong-zhi-cheng',
    title: '暗涌之城',
    type: 'tv',
    genres: ['悬疑', '犯罪', '剧情'],
    year: 2025,
    region: '中国大陆',
    rating: 9.1,
    director: '秦朗',
    actors: ['方岩', '沈黎', '赵岑'],
    synopsis:
      '滨海市接连发生几起看似无关的意外，记者沈黎在调查中拼凑出一张庞大的利益网络。当真相越来越近，她不得不面对自己家族也被卷入其中的残酷现实。',
    episodeCount: 32,
    status: '更新至 18 集',
    updatedAt: '2025-10-12 21:00',
    poster:
      'https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20poster%20with%20a%20journalist%20silhouette%20among%20skyscrapers%20and%20fog%2C%20cold%20navy%20and%20amber%20light%2C%20tense%20mysterious%20urban%20atmosphere%2C%20high%20contrast&width=600&height=900&seq=hn-poster-anyong&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Moody%20coastal%20city%20skyline%20at%20dusk%20with%20fog%20rolling%20between%20towers%2C%20amber%20window%20lights%2C%20dark%20navy%20thriller%20cinematic%20still&width=1600&height=900&seq=hn-back-anyong&orientation=landscape',
    isHot: true,
  },
  {
    id: 'wo-men-de-shi-nian',
    title: '我们的十年',
    type: 'tv',
    genres: ['都市', '情感', '剧情'],
    year: 2024,
    region: '中国大陆',
    rating: 8.0,
    director: '林未',
    actors: ['夏川', '顾念', '周炎'],
    synopsis:
      '四个大学室友毕业后各奔东西，十年间在职场、爱情与家庭间跌跌撞撞。每当有人撑不住，那间老出租屋的群聊就会亮起，提醒他们青春从未散场。',
    episodeCount: 36,
    status: '全 36 集',
    updatedAt: '2025-07-30 19:15',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20urban%20drama%20poster%20of%20four%20young%20friends%20sitting%20on%20a%20rooftop%20at%20sunset%2C%20city%20skyline%20behind%2C%20amber%20and%20coral%20tones%2C%20youthful%20hopeful%20mood&width=600&height=900&seq=hn-poster-shinian&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=City%20rooftop%20at%20golden%20hour%20overlooking%20a%20modern%20skyline%2C%20warm%20amber%20and%20peach%20sky%2C%20urban%20drama%20cinematic%20still%20with%20soft%20glow&width=1600&height=900&seq=hn-back-shinian&orientation=landscape',
    isHot: false,
  },
  {
    id: 'yi-zhe-ren-xin',
    title: '医者仁心',
    type: 'tv',
    genres: ['医疗', '剧情'],
    year: 2024,
    region: '中国大陆',
    rating: 8.3,
    director: '吴承',
    actors: ['韩沐', '苏婉', '杜衡'],
    synopsis:
      '急诊科医生韩沐在高压的夜班里一次次与时间赛跑。面对家属的误解与制度的掣肘，他和同事们依然选择站在病床前，守住那句被人遗忘的誓言。',
    episodeCount: 30,
    status: '全 30 集',
    updatedAt: '2025-06-18 20:45',
    poster:
      'https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20with%20a%20doctor%20in%20scrubs%20standing%20in%20a%20dim%20hospital%20corridor%2C%20cool%20navy%20with%20warm%20amber%20accent%2C%20serious%20hopeful%20tone%2C%20soft%20focus&width=600&height=900&seq=hn-poster-yizhe&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Modern%20hospital%20emergency%20department%20at%20night%20with%20warm%20window%20light%20and%20quiet%20corridors%2C%20soft%20navy%20and%20amber%20tones%2C%20cinematic%20medical%20drama%20still&width=1600&height=900&seq=hn-back-yizhe&orientation=landscape',
    isHot: false,
  },
  {
    id: 'shao-nian-ge-xing-tian-xia',
    title: '少年歌行天下',
    type: 'tv',
    genres: ['武侠', '热血', '古装'],
    year: 2025,
    region: '中国大陆',
    rating: 8.8,
    director: '洛无涯',
    actors: ['裴野', '云舒', '白霖'],
    synopsis:
      '出身小镇的裴野带着一把断剑闯入江湖，只为寻找失踪的兄长。他在门派纷争与家国大义间成长，从无名少年一路走到天下皆知的名字。',
    episodeCount: 45,
    status: '更新至 30 集',
    updatedAt: '2025-10-10 20:30',
    poster:
      'https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20drama%20poster%20of%20a%20young%20swordsman%20holding%20a%20broken%20sword%20in%20bamboo%20forest%2C%20green%20and%20amber%20light%2C%20dynamic%20heroic%20pose%2C%20mist&width=600&height=900&seq=hn-poster-shaonian&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Ethereal%20bamboo%20forest%20at%20dawn%20with%20golden%20light%20rays%20and%20a%20lone%20swordsman%20walking%2C%20misty%20green%20and%20amber%20palette%2C%20epic%20wuxia%20cinematic%20scene&width=1600&height=900&seq=hn-back-shaonian&orientation=landscape',
    isHot: true,
  },
  {
    id: 'bao-xiao-shi-yan-shi',
    title: '爆笑实验室',
    type: 'variety',
    genres: ['喜剧', '真人秀', '综艺'],
    year: 2025,
    region: '中国大陆',
    rating: 8.5,
    director: '综艺制作组',
    actors: ['何欢', '胖墩', '阿吉', '小满'],
    synopsis:
      '一群脑洞大开的喜剧人把日常难题搬进实验室，用最离谱的方式给出最意想不到的答案。每期一个新主题，笑点与温情齐飞。',
    episodeCount: 12,
    status: '更新至 9 期',
    updatedAt: '2025-10-09 21:00',
    poster:
      'https://readdy.ai/api/search-image?query=Fun%20variety%20show%20poster%20with%20colorful%20props%20and%20confetti%20explosion%2C%20playful%20bold%20typography%20space%2C%20warm%20orange%20and%20yellow%20tones%2C%20energetic%20joyful%20mood&width=600&height=900&seq=hn-poster-baoxiao&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Bright%20colorful%20variety%20show%20stage%20with%20neon%20lights%2C%20confetti%20and%20stage%20props%2C%20warm%20orange%20and%20coral%20palette%2C%20fun%20energetic%20atmosphere&width=1600&height=900&seq=hn-back-baoxiao&orientation=landscape',
    isHot: false,
  },
  {
    id: 'wu-tai-zhi-wang',
    title: '舞台之王',
    type: 'variety',
    genres: ['音乐', '竞演', '综艺'],
    year: 2025,
    region: '中国大陆',
    rating: 9.0,
    director: '音乐竞演团队',
    actors: ['多位实力唱将'],
    synopsis:
      '来自不同世代的歌手同台竞演，每一轮都要挑战完全不同风格的曲目。舞台之上只有实力说话，而聚光灯之外，是他们对音乐最纯粹的热爱。',
    episodeCount: 14,
    status: '更新至 11 期',
    updatedAt: '2025-10-12 20:00',
    poster:
      'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20with%20a%20singer%20silhouette%20in%20a%20single%20spotlight%20on%20stage%2C%20golden%20and%20deep%20navy%20tones%2C%20dramatic%20elegant%20concert%20mood&width=600&height=900&seq=hn-poster-wutai&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20golden%20spotlights%20beams%20and%20a%20packed%20audience%20in%20silhouette%2C%20deep%20navy%20and%20amber%20palette%2C%20cinematic%20live%20music%20scene&width=1600&height=900&seq=hn-back-wutai&orientation=landscape',
    isHot: true,
  },
  {
    id: 'cheng-shi-wei-dao',
    title: '城市味道',
    type: 'variety',
    genres: ['美食', '纪实', '综艺'],
    year: 2024,
    region: '中国大陆',
    rating: 8.9,
    director: '纪实团队',
    actors: ['主持人 阿辉'],
    synopsis:
      '走进一座座城市的清晨与深夜，寻访藏在巷弄里的老味道。每一道菜背后，都是一段关于坚持、离别与团聚的人间故事。',
    episodeCount: 10,
    status: '全 10 期',
    updatedAt: '2025-05-22 18:30',
    poster:
      'https://readdy.ai/api/search-image?query=Food%20documentary%20poster%20with%20steaming%20bowl%20of%20noodles%20and%20warm%20street%20lanterns%2C%20cozy%20amber%20and%20terracotta%20tones%2C%20appetizing%20warm%20inviting%20mood&width=600&height=900&seq=hn-poster-chengshi&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Bustling%20old%20chinese%20night%20food%20street%20with%20warm%20lanterns%20and%20steaming%20stalls%2C%20amber%20and%20coral%20glow%2C%20cozy%20documentary%20cinematic%20still&width=1600&height=900&seq=hn-back-chengshi&orientation=landscape',
    isHot: false,
  },
  {
    id: 'chu-fa-ba-peng-you',
    title: '出发吧朋友',
    type: 'variety',
    genres: ['旅行', '户外', '综艺'],
    year: 2025,
    region: '中国大陆',
    rating: 8.1,
    director: '旅行真人秀团队',
    actors: ['嘉宾团'],
    synopsis:
      '六位性格迥异的朋友自驾穿越山河，一路上没有剧本，只有真实的争吵、和解与感动。旅途的意义，从来不只是抵达终点。',
    episodeCount: 12,
    status: '更新至 8 期',
    updatedAt: '2025-10-07 19:00',
    poster:
      'https://readdy.ai/api/search-image?query=Travel%20reality%20show%20poster%20with%20friends%20and%20an%20off%20road%20van%20on%20a%20mountain%20road%2C%20golden%20sunset%20and%20teal%20sky%2C%20adventurous%20warm%20free%20mood&width=600&height=900&seq=hn-poster-chufa&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sweeping%20mountain%20highway%20at%20golden%20hour%20with%20a%20lone%20van%20driving%20toward%20distant%20peaks%2C%20warm%20amber%20and%20teal%20palette%2C%20cinematic%20travel%20scene&width=1600&height=900&seq=hn-back-chufa&orientation=landscape',
    isHot: false,
  },
];

export const videoTypeLabels: Record<string, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
};

export const videoTypeDescriptions: Record<string, string> = {
  movie: '汇聚剧情、动作、悬疑、奇幻等各类型院线佳作与口碑影片，高清画质一站直达。',
  tv: '古装、都市、悬疑、武侠全类型剧集持续更新，追剧党的观剧日历从此不再错过。',
  variety: '音乐竞演、美食纪实、旅行真人秀、喜剧综艺应有尽有，承包你的每一份快乐。',
};